<template>
	<ManagingSection
		:isTable="true"
		tableTitle="당첨자"
		:bodyScrollTable="true"
		class="stamp-winner-list"
	>
		<template slot="topBar">
			<RadioList
				:value="groupTab"
				:radioList="groupTabList"
				@input="groupTabInput"
			/>
			<div class="section__info__right">
				<button
					class="btn red section__info__items"
					v-text="'선택삭제'"
					:disabled="!checkListLength"
					@click="removeWinners"
				/>
				<button
					class="btn-excel section__info__items"
					v-text="'CSV'"
					@click="$store.dispatch('stamp/csvDown', true)"
				/>
				<Selector
					:value="order"
					:optionList="orderList"
					class="section__info__items"
					@input="orderInput"
				/>
			</div>
		</template>
		<RegisterList
			slot="bodyScrollTable"
			ref="registerList"
			:list="list"
			@changeCheckListLength="changeCheckListLength"
		/>
	</ManagingSection>
</template>
<script>
	import { mapState, mapGetters } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import RadioList from '@/components/RadioList.vue';
	import Selector from '@/components/Selector.vue';
	import RegisterList from '@/components/stamp/winner/RegisterList.vue';

	export default {
		name: 'StampWinnerList',
		components: {
			ManagingSection,
			ManagingBox,
			RadioList,
			Selector,
			RegisterList,
		},
		data() {
			return {
				id: this.$route.params.idStamp,
				checkListLength: 0,
			};
		},
		computed: {
			...mapState({
				groupTab: state => state.stamp.groupTab,
				orderList: state => state.stamp.orderList,
				order: state => state.stamp.winnerListOrder,
				list: state => state.stamp.currTabWinnerList,
			}),
			...mapGetters({
				groupTabList: 'stamp/groupTabList',
			}),
		},
		methods: {
			changeCheckListLength(v) {
				const length = v || 0;
				this.checkListLength = length;
				this.$emit('selectedWinnerLengthChange', length);
			},
			initCheck() {
				this.$refs.registerList.initCheck();
			},
			async setWinnerList() {
				await this.$store.dispatch('stamp/setWinnerList');
			},
			async setBothWinnerList(func) {
				this.$store.commit('toggleSpinner', true);
				await Promise.all([
					this.$store.dispatch('stamp/setTargetGroupWinnerList'),
					this.setWinnerList(),
				]);
				func();
				this.$store.commit('toggleSpinner', false);
			},
			groupTabInput(value) {
				if (value) {
					this.$store.commit('stamp/changeState', [
						{ key: 'targetGroup', value },
					]);
				}
				this.$store.commit('stamp/changeState', [
					{ key: 'groupTab', value },
				]);
				this.setBothWinnerList(() => this.$emit('initCheck', 'winner'));
			},
			async removeWinners() {
				try {
					this.$store.commit('toggleSpinner', true);
					const params = {
						register_ids: this.$refs.registerList.checkListModel,
					};
					await this.$axiosAdmin2NoSpinner.delete(
						`/v3/api/stamp/${this.id}/winner-delete`,
						{ data: params }
					);
					this.setBothWinnerList(() => this.$emit('initCheck'));
				} catch (e) {
					console.error(e);
					alert('당첨자 삭제 실패!');
				} finally {
					this.$store.commit('toggleSpinner', false);
				}
			},
			async setWinnerListWithSpinner(func) {
				this.$store.commit('toggleSpinner', true);
				await this.setWinnerList();
				func();
				this.$store.commit('toggleSpinner', false);
			},
			orderInput(value) {
				this.$store.commit('stamp/changeState', [
					{ key: 'winnerListOrder', value },
				]);
				this.setWinnerListWithSpinner(() =>
					this.$emit('initCheck', 'winner')
				);
			},
		},
	};
</script>
<style lang="scss" scoped>
	.stamp-winner-list {
		&::v-deep {
			.section__table-top-bar {
				display: flex;
				justify-content: space-between;

				&:after {
					content: none;
				}
			}
		}
	}
</style>
